import React from "react";
import { useState } from "@vrf/fr-vrf-core-react";
import { HomePageContext, HomePageInitialState } from ".";
import { DesignInfoInputDialogStateProvider } from "../dialog/design-info-input-dialog";
import { MemoEditDialogStateProvider } from "../dialog/memo-edit-dialog";

export const HomePageStateProvider = ({ children }: any) => {
  const [pageState, setPageState] = useState(HomePageInitialState);
  const context = {
    pageState: pageState,
    setPageState: setPageState,
  };
  return (
    <MemoEditDialogStateProvider>
      <HomePageContext.Provider value={context}>
        {children}
      </HomePageContext.Provider>
    </MemoEditDialogStateProvider>
  );
};
